import request from "@/api";

export function listSupplier(data) {
    return request({
        url: '/api/supplier/getSupplierList',
        method: 'get',
        params: data
    })
}

export function getSupplierInfo(data) {
    return request({
        url: '/api/supplier/getSupplierInfo',
        method: 'get',
        params: data
    })
}

export function saveSupplier(data) {
    return request({
        url: '/api/supplier/saveSupplier',
        method: 'post',
        data: data
    })
}

export function deleteSupplier(data) {
    return request({
        url: '/api/supplier/deleteSupplier',
        method: 'post',
        data: data
    })
}

export function exportSupplier(data) {
    return request({
        url: '/api/supplier/export',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}